__turbopack_context__.v({
  "bannerImage": "bhcmTG_bannerImage",
  "container": "bhcmTG_container",
  "disabled": "bhcmTG_disabled",
  "imageContainer": "bhcmTG_imageContainer",
  "imageOnTopStyle": "bhcmTG_imageOnTopStyle",
  "placeholderImage": "bhcmTG_placeholderImage",
});
